<template lang="html">
  <div class="container-fluid" style="height: 100vh">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="manageshipmentdet">
          <div class="container-fluid p-0 d-flex flex-column" style="height: 100%;">
            <HeaderBox class="_requestlistsstatus__header"
              :custDetail="contractData"
              :isLoading="isLoading"
              :typeRequest="'Contract'"
              :prevRoute="prevRoute"
              >
            </HeaderBox>
            <div class="col-md p-0 manageshipmentdet__mastercontent" v-if="contractData">
              <div class="row m-0" style="height: 100%">
                <div class="col-md-4 p-0 manageshipmentdet__mastercontent--left">
                  <GroupChat :custDetail="contractData"></GroupChat>
                </div>
                <div class="col-md p-0 manageshipmentdet__mastercontent--right pl-1">
                  <div class="row m-0 manageshipment__topcontent">
                    <button class="col-md p-0 mastercontent__tabs" v-for="tab in tabs"
                        :key="tab.id" :class="[{ 'mastercontent__tabs--selected':
                        selectedtabs === tab.content}, contractData && contractData.service_head === 'AIR' &&
                      selectedtabs === tab.content ? 'global__bc_purple' : contractData && contractData.service_head === 'OCEAN'
                      && selectedtabs === tab.content ? 'global__bc_blue' : '']" @click="selectedtabs = tab.content">
                        <p>{{ tab.title }}</p>
                    </button>
                  </div>
                  <div class="manageshipment__content">
                    <keep-alive>
                      <component
                        :is="selectedtabs"
                        :custDetail="contractData"
                        :isLoading="isLoading"
                        :typeRequest="'Contract'"
                        >
                      </component>
                    </keep-alive>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import HeaderBox from '@/components/requestList/detail/HeaderBox'
import Quotation from '@/components/requestList/detail/Quotation'
import Details from '@/components/requestList/detail/Details'
import Documents from '@/components/requestList/detail/Documents'
import GroupChat from '@/components/requestList/detail/GroupChat'
import Ongoing from '@/components/requestList/detail/Ongoing'
import mixinGetStatus from '@/mixin/getters/status-bid'
import { mapGetters } from 'vuex'

export default {
  name: 'requestListContract',
  mixins: [mixinGetStatus],
  components: {
    Sidebar,
    HeaderBox,
    GroupChat,
    Ongoing,
    Documents,
    Quotation
  },
  data () {
    return {
      selectedtabs: Quotation,
      prevRoute: null,
      tabs: [
        {
          id: 1,
          title: 'QUOTATION',
          content: Quotation
        },
        {
          id: 2,
          title: 'DETAILS',
          content: Details
        },
        {
          id: 3,
          title: 'DOCUMENTS',
          content: Documents
        }
      ]
    }
  },
  mounted () {
    this.fetchContract()
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    ...mapGetters({
      isLoadingBid: 'rfq/isLoadingBid',
      isErrorLoadingBid: 'rfq/isErrorLoadingBid',
      bidList: 'rfq/bids',

      contractData: 'contract/item',
      isLoading: 'contract/isLoading',
      isError: 'contract/error'
    })
  },
  methods: {
    fetchContract () {
      const id = this.$route.params.id_contract
      this.$store.dispatch('contract/FETCH_CONTRACT_BY_ID', id)
    }
  },
  watch: {
    contractData (data) {
      if (data) {
        if (this.getStatus(data) === 'On Going' || this.getStatus(data) === 'Completed') {
          this.tabs[0].title = 'ON GOING'
          this.tabs[0].content = Ongoing
          if (this.selectedtabs === Quotation) {
            this.selectedtabs = Ongoing
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/requestlistDetail/contract/index.vue